<template>
    <div class="ma-page">
        <!-- Hero -->
        <section class="ma-hero">
            <div class="ma-hero__bg-shape ma-hero__bg-shape--2"></div>
            <div class="ma-hero__inner">
                <div class="ma-hero__text">
                    <div class="ma-badge">
                        <span class="ma-badge__dot"></span>
                        Inscripciones abiertas
                    </div>
                    <h1 class="ma-hero__title">
                        Curso de<br>
                        <span class="ma-hero__title--accent">Manipulación</span><br>
                        de Alimentos
                    </h1>
                    <p class="ma-hero__desc">
                        Capacitación <strong>asincrónica y gratuita</strong> — estudiá a tu ritmo,
                        desde tu casa. 5 módulos con evaluación final y certificación.
                    </p>
                    <div class="ma-hero__actions">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScOejM8PRXgKtx8K8QpLB7BSeEO_-ABGPD2zH_Jg6LnGohncA/viewform"
                           target="_blank"
                           class="ma-btn ma-btn--primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
                            Inscribirme ahora
                        </a>
                    </div>
                </div>
                <div class="ma-hero__video">
                    <div class="ma-video">
                        <div class="ma-video__frame">
                            <iframe
                                src="https://www.youtube.com/embed/JnOeO_BDWCg"
                                title="Manipulación de Alimentos"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div>
                        <div class="ma-video__label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                            Video introductorio
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Módulos -->
        <section class="ma-modules">
            <div class="ma-modules__inner">
                <div class="ma-module" v-for="(mod, i) in modules" :key="i">
                    <div class="ma-module__number">{{ String(i + 1).padStart(2, '0') }}</div>
                    <div class="ma-module__content">
                        <h3 class="ma-module__title">{{ mod.title }}</h3>
                        <p class="ma-module__desc">{{ mod.desc }}</p>
                    </div>
                    <div class="ma-module__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    </div>
                </div>
            </div>
        </section>

        <!-- CTA Final -->
        <section class="ma-cta">
            <div class="ma-cta__inner">
                <div class="ma-cta__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                </div>
                <div class="ma-cta__text">
                    <h2>¿Cómo funciona?</h2>
                    <p>
                        Completá el formulario de inscripción y accedé
                        inmediatamente al aula virtual con todo el material de estudio,
                        los 5 módulos y la evaluación final.
                    </p>
                </div>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScOejM8PRXgKtx8K8QpLB7BSeEO_-ABGPD2zH_Jg6LnGohncA/viewform"
                   target="_blank"
                   class="ma-btn ma-btn--secondary">
                    Comenzar el curso
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </a>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "ManipulacionAlimentos",
    data() {
        return {
            modules: [
                { title: "A tu ritmo", desc: "100% online y asincrónico, sin horarios fijos" },
                { title: "5 Módulos", desc: "Contenido estructurado y progresivo" },
                { title: "Evaluación final", desc: "Validá lo aprendido con un examen integrador" },
                { title: "Certificación", desc: "Obtené tu certificado oficial al aprobar" },
            ]
        }
    }
}
</script>

<style scoped>
/* ══════════════════════════════════════════
   TOKENS — site system
   ══════════════════════════════════════════ */
.ma-page {
    --ma-brand: #FF8200;
    --ma-brand-dark: #e07300;
    --ma-dark: #1D252D;
    --ma-blue: #162787;
    --ma-gray-600: #6c757d;
    --ma-gray-200: #e9ecef;
    --ma-gray-100: #f2f2f2;
    --ma-white: #ffffff;
    --ma-radius: 0.5rem;
    --ma-radius-lg: 1rem;

    font-family: 'Ubuntu-Regular', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: var(--ma-dark);
    background: var(--ma-gray-100);
    min-height: 100vh;
}

/* ══════════════════════════════════════════
   HERO
   ══════════════════════════════════════════ */
.ma-hero {
    position: relative;
    background: var(--ma-dark);
    padding: 4rem 2rem 5rem;
    overflow: hidden;
}

.ma-hero__bg-shape--2 {
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(22, 39, 135, 0.1) 0%, transparent 70%);
    bottom: -10%;
    left: -5%;
    pointer-events: none;
}

.ma-hero__inner {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 4rem;
    align-items: center;
    position: relative;
    z-index: 1;
}

/* Badge */
.ma-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(255, 130, 0, 0.15);
    color: var(--ma-brand);
    padding: 0.4rem 1rem;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 1.5rem;
    animation: maFadeIn 0.6s ease-out;
}

.ma-badge__dot {
    width: 6px;
    height: 6px;
    background: var(--ma-brand);
    border-radius: 50%;
    animation: maPulse 2s ease-in-out infinite;
}

@keyframes maPulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
}

@keyframes maFadeIn {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Title */
.ma-hero__title {
    font-family: 'Ubuntu-Bold', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: clamp(2.25rem, 5vw, 3.5rem);
    font-weight: 700;
    line-height: 1.15;
    color: var(--ma-white);
    margin: 0 0 1.25rem 0;
    animation: maFadeIn 0.6s ease-out 0.1s backwards;
}

.ma-hero__title--accent {
    color: var(--ma-brand);
}

.ma-hero__desc {
    font-size: 1.05rem;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.6);
    max-width: 480px;
    margin: 0 0 2rem 0;
    animation: maFadeIn 0.6s ease-out 0.2s backwards;
}

.ma-hero__desc strong {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
}

.ma-hero__actions {
    animation: maFadeIn 0.6s ease-out 0.3s backwards;
}

/* Button */
.ma-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    font-family: 'Ubuntu-Medium', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-weight: 500;
    font-size: 0.95rem;
    text-decoration: none;
    border-radius: var(--ma-radius);
    transition: all 0.25s ease;
    cursor: pointer;
}

.ma-btn--primary {
    background: var(--ma-brand);
    color: var(--ma-white);
    padding: 0.85rem 1.75rem;
    box-shadow: 0 4px 16px rgba(255, 130, 0, 0.3);
}

.ma-btn--primary:hover {
    background: var(--ma-brand-dark);
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(255, 130, 0, 0.4);
    color: var(--ma-white);
}

.ma-btn--secondary {
    background: var(--ma-dark);
    color: var(--ma-white);
    padding: 0.75rem 1.5rem;
    border: 1px solid rgba(29, 37, 45, 0.2);
}

.ma-btn--secondary:hover {
    background: var(--ma-brand);
    border-color: var(--ma-brand);
    transform: translateY(-2px);
    color: var(--ma-white);
}

/* Video */
.ma-hero__video {
    animation: maFadeIn 0.7s ease-out 0.3s backwards;
}

.ma-video {
    position: relative;
}

.ma-video__frame {
    width: 100%;
    aspect-ratio: 9 / 16;
    border-radius: var(--ma-radius-lg);
    overflow: hidden;
    box-shadow:
        0 20px 50px -12px rgba(0, 0, 0, 0.5),
        0 0 0 1px rgba(255, 255, 255, 0.06);
    background: #000;
}

.ma-video__frame iframe {
    width: 100%;
    height: 100%;
    display: block;
}

.ma-video__label {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    margin-top: 0.75rem;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.4);
    letter-spacing: 0.03em;
}

/* ══════════════════════════════════════════
   MODULES
   ══════════════════════════════════════════ */
.ma-modules {
    padding: 0 2rem;
    margin-top: -2rem;
    position: relative;
    z-index: 10;
}

.ma-modules__inner {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1px;
    background: var(--ma-gray-200);
    border-radius: var(--ma-radius-lg);
    overflow: hidden;
    box-shadow: 0 8px 30px -8px rgba(0, 0, 0, 0.12);
}

.ma-module {
    background: var(--ma-white);
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    transition: background 0.25s ease;
    position: relative;
}

.ma-module:hover {
    background: #fffaf5;
}

.ma-module:hover .ma-module__icon {
    color: var(--ma-brand);
    transform: translateX(2px);
}

.ma-module__number {
    font-size: 0.7rem;
    font-weight: 700;
    color: var(--ma-brand);
    letter-spacing: 0.05em;
    opacity: 0.7;
}

.ma-module__content {
    flex: 1;
}

.ma-module__title {
    font-size: 1rem;
    font-weight: 500;
    margin: 0 0 0.25rem 0;
    color: var(--ma-dark);
}

.ma-module__desc {
    font-size: 0.8rem;
    color: var(--ma-gray-600);
    margin: 0;
    line-height: 1.5;
}

.ma-module__icon {
    color: var(--ma-gray-200);
    transition: all 0.25s ease;
    align-self: flex-end;
}

/* ══════════════════════════════════════════
   CTA
   ══════════════════════════════════════════ */
.ma-cta {
    padding: 4rem 2rem 5rem;
}

.ma-cta__inner {
    max-width: 800px;
    margin: 0 auto;
    background: var(--ma-white);
    border-radius: var(--ma-radius-lg);
    padding: 2.5rem;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.06);
    border: 1px solid var(--ma-gray-200);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.ma-cta__inner:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.1);
}

.ma-cta__icon {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, rgba(255, 130, 0, 0.1) 0%, rgba(255, 130, 0, 0.05) 100%);
    border-radius: var(--ma-radius);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ma-brand);
}

.ma-cta__text {
    flex: 1;
}

.ma-cta__text h2 {
    font-family: 'Ubuntu-Medium', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0 0 0.4rem 0;
}

.ma-cta__text p {
    font-size: 0.9rem;
    color: var(--ma-gray-600);
    line-height: 1.6;
    margin: 0;
}

/* ══════════════════════════════════════════
   RESPONSIVE
   ══════════════════════════════════════════ */
@media (max-width: 992px) {
    .ma-hero__inner {
        grid-template-columns: 1fr;
        gap: 3rem;
        text-align: center;
    }

    .ma-hero__desc {
        margin-left: auto;
        margin-right: auto;
    }

    .ma-hero__video {
        max-width: 260px;
        margin: 0 auto;
    }

    .ma-modules__inner {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .ma-hero {
        padding: 3rem 1.5rem 4rem;
    }

    .ma-modules {
        padding: 0 1rem;
    }

    .ma-modules__inner {
        grid-template-columns: 1fr;
    }

    .ma-module {
        flex-direction: row;
        align-items: center;
    }

    .ma-module__icon {
        align-self: center;
    }

    .ma-cta {
        padding: 3rem 1rem;
    }

    .ma-cta__inner {
        flex-direction: column;
        text-align: center;
        padding: 2rem 1.5rem;
    }
}

@media (max-width: 480px) {
    .ma-hero {
        padding: 2rem 1rem 3.5rem;
    }

    .ma-hero__title {
        font-size: 2rem;
    }

    .ma-btn--primary {
        width: 100%;
        justify-content: center;
    }
}
</style>
